import { Directive, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Params } from '@angular/router';
import { OrderData } from '@zero/shared/util-models';
import { DataService } from '@zero/shared/util-web-app-services';
import { TradeService } from '@zero/trade/domain';
import { commonRoutes } from 'constants/web-app-constants';

@Directive()
export class OrderItemBase implements OnChanges {
  @Input() public order!: OrderData;
  @Input() public actionsEnabled = true;

  public orderQueryParams: Params;
  public readonly commonRoutes = commonRoutes;

  readonly #tradeService = inject(TradeService);
  public readonly dataService = inject(DataService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['order']?.currentValue && changes['order'].currentValue !== changes['order'].previousValue) {
      this.orderQueryParams = this.#tradeService.createQueryParams(this.order);
    }
  }
}
